import { useTranslation } from 'react-i18next';

import { FileDropzone, Form } from 'coreOld/components';
import { IFile, IFileUpload } from 'coreOld/types';

import { fileSchema } from './fileUploadSchema';

const MIN_WIDTH = 500;

interface IProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  files?: IFile[];
  onFileDrop?: (files: IFile[]) => void;
  onRemoveFile?: (file: IFile) => void;
  onSubmit?: () => () => void;
}

const FileUploadFormView = ({
  isOpen,
  onClose,
  title,
  files,
  onFileDrop,
  onRemoveFile,
  onSubmit,
}: IProps) => {
  const { t } = useTranslation();

  return (
    <Form<IFileUpload>
      isOpen={isOpen}
      onClose={onClose}
      title={title || t('labelUploadFiles')}
      submitBtnLabel={t('buttonLabelUpload')}
      onSubmit={onSubmit}
      schema={fileSchema}
      minWidth={MIN_WIDTH}
    >
      <FileDropzone files={files} onFileDrop={onFileDrop} onRemoveFile={onRemoveFile} />
    </Form>
  );
};

export default FileUploadFormView;
